module.exports = __webpack_public_path__ + "static/media/plus-border.4c12b14a.webp";